/*
 * @Author: LiuMeiYu
 * @Date: 2023-04-25 16:53:42
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-19 16:24:59
 * @FilePath: \nexcross_b\src\router\index.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
import { createRouter, createWebHistory } from "vue-router";
import Layout from "../template/layoutView.vue";
import { nextTick } from "vue";
import { getAccessToken } from "@/utils/auth";

const routes = [
  {
    path: "",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "404" */ "@/views/LoginView.vue"),
    meta: {
      title: "Login",
      requireAuth: false,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
    meta: {
      title: "Not Found Page",
      requireAuth: false,
    },
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/HomeView.vue"),
        meta: {
          title: "Home",
          requireAuth: false,
        },
      },
      {
        path: "/transactionRecord",
        name: "TransactionRecord",
        component: () =>
          import(
            /* webpackChunkName: "Transaction Record" */
            "@/views/TransactionRecord/TransactionRecordView.vue"
          ),
        meta: {
          title: "Transaction Record",
          requireAuth: false,
        },
      },
      {
        path: "/payee",
        name: "Payee",
        component: () =>
          import(
            /* webpackChunkName: "Payee" */
            "@/views/Payee/PayeeView.vue"
          ),
        meta: {
          title: "Payee",
          requireAuth: false,
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
// 防止连续点击多次路由报错
let routerPush = createRouter.prototype.push;
createRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

// 全局路由导航拦截
router.beforeEach((to) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "Nexcross";
  }
  // 是否是登录页
  if (to.path !== "/login") {
    // 不是登录页 判断是否需要登录 && sessionStorage.getItem("token")
    // 判断是否已经登录
    if (getAccessToken()) {
      return true;
    } else {
      nextTick(() => {
        router.push({ path: "/login", query: { redirect: to.fullPath } });
        return true;
      });
    }
  } else {
    return true;
  }
});

export default router;
